import React from 'react';
import { EllipsisTooltip } from '@src/components/common';
import { StyledBreadcrumb } from './styled';

function SummaryBreadcrumb({ drilldown = [], applyFilterFromBreadcrumb }) {

  const handleClickFn = (key) => {
    return (e) => {
      e.preventDefault();
      applyFilterFromBreadcrumb(key);
    }
  }

  return drilldown.length > 1 ? (
      <StyledBreadcrumb separator=">" style={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontSize: 12,
      }}>
        {drilldown.map((item, key) => (
          <StyledBreadcrumb.Item key={item.name} href="" onClick={handleClickFn(key)} style={{ maxWidth: 200 }} >
            <EllipsisTooltip tooltipText={item.name}>
              {item.name}
            </EllipsisTooltip>
          </StyledBreadcrumb.Item>
        ))}
      </StyledBreadcrumb>
  ) : null;
}

export default SummaryBreadcrumb;
